/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Updatesuccess1Inputs */

const zh_common_updatesuccess1 = /** @type {(inputs: Common_Updatesuccess1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新成功`)
};

const en_common_updatesuccess1 = /** @type {(inputs: Common_Updatesuccess1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated successfully`)
};

const es_common_updatesuccess1 = /** @type {(inputs: Common_Updatesuccess1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizado correctamente`)
};

/**
* | output |
* | --- |
* | "Updated successfully" |
*
* @param {Common_Updatesuccess1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const common_updatesuccess1 = /** @type {((inputs?: Common_Updatesuccess1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Updatesuccess1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_common_updatesuccess1(inputs)
	if (locale === "en") return en_common_updatesuccess1(inputs)
	return es_common_updatesuccess1(inputs)
});
export { common_updatesuccess1 as "common_updateSuccess" }